exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divider-dotted[data-v-e19442d4] {\n\tposition: relative;\n\tmargin: 8px 0 8px 0;\n\tborder-top: none;\n\tborder-left: none;\n\tborder-right: none;\n\tborder-bottom: 0.145rem dotted rgba(226, 230, 235, 0.85);\n}\n.text-bold[data-v-e19442d4] {\n\tfont-weight: 600;\n\tfont-size: 1rem;\n}\n.text-color[data-v-e19442d4] {\n\tfont-size: 12px !important;\n\tcolor: rgba(6, 38, 62, 0.84) !important;\n}\n.text-empty-person[data-v-e19442d4] {\n\tmargin-top: -8px;\n\tcolor: #ea4e2c;\n\tfont-size: 13px;\n\tletter-spacing: 0.05em;\n\tfont-weight: 600;\n}\n", ""]);

// exports
